export const storeAction = {
    //auth module actions
    initiateLoginRedirect: 'initiateLoginRedirect',
    getFeatureFlag: 'getFeatureFlag',
    sendMobileMessage: 'sendMobileMessage',
    sendSessionExpirationNoticeToMobileApps: "sendSessionExpirationNoticeToMobileApps",
    submitForgotPassword: 'submitForgotPassword',
    getPasswordRecoveryOptions: 'getPasswordRecoveryOptions',
    submitUsernameRecoveryEmail: 'submitUsernameRecoveryEmail',
    submitUsernameFurtherAssistance: 'submitUsernameFurtherAssistance',
    submitPasswordFurtherAssistance: 'submitPasswordFurtherAssistance',
    submitPasswordFurtherSecurityForMember: 'submitPasswordFurtherSecurityForMember',
    submitLoginAssistanceForSpousePartner: 'submitLoginAssistanceForSpousePartner',
    submitSelectTypePasswordDelivery: 'submitSelectTypePasswordDelivery',
    submitPasswordRecoveryOption: 'submitPasswordRecoveryOption',
    submitRecoveryToken: 'submitRecoveryToken',
    submitRecoverySmsCode: 'submitRecoverySmsCode',
    answerSecurityQuestion: 'answerSecurityQuestion',
    resetPassword: 'resetPassword',
    submitLogin: 'submitLogin',
    submitLogout: 'submitLogout',
    handlePostLogoutCleanUp: 'handlePostLogoutCleanUp',
    validateAuthentication: 'validateAuthentication',
    authenticateUser: 'authenticateUser',
    fetchNewOktaToken: 'fetchNewOktaToken',
    setAuthDataInState: 'setAuthDataInState',
    refreshOktaAccessToken: 'refreshOktaAccessToken',
    startOktaTokenRefreshTimer: 'startOktaTokenRefreshTimer',
    setSessionInState: 'setSessionInState',
    setSessionExpiration: 'setSessionExpiration',
    logoutAfterSessionExpired: "logoutAfterSessionExpired",
    handleLoginErrorMessage: 'handleLoginErrorMessage',
    submitUsernameRecoveryOption: 'submitUsernameRecoveryOption',
    getusersCommunitiesList: 'getusersCommunitiesList',
    getMentionsList: 'getMentionsList',
    getCommunityById: 'getCommunityById',
    getCommunityByName: 'getCommunityByName',
    clearYpoStoredDetails: 'clearYpoStoredDetails',
    saveTermsAndConditions: 'saveTermsAndConditions',
    getPermissions: 'getPermissions',
    getSystemMessages: 'getSystemMessages',
    logoutAndClearSession: 'logoutAndClearSession',

    //ypo Search actions
    getPeopleOneClickSearchSuggestions: 'getPeopleOneClickSearchSuggestions',
    getPeopleSearchSuggestions: 'getPeopleSearchSuggestions',
    getEventSearchSuggestions: 'getEventSearchSuggestions',
    getCommunitySearchSuggestions: 'getCommunitySearchSuggestions',
    getContentSearchSuggestions: 'getContentSearchSuggestions',
    initiateTracking: 'initiateTracking',

    //YPO Resources
    getYpoResources: "getYpoResources",
    saveYpoResourcesCategories: "saveYpoResourcesCategories",
    saveYpoResourcesLinks: "saveYpoResourcesLinks",
    saveYpoResourcesButtons: "saveYpoResourcesButtons",

    // Ypo Concierge
    initiateConciergeService: 'initiateConciergeService',
    determineConciergeServiceAvailability: 'determineConciergeServiceAvailability',
    retrieveYpoConciergeTopics: 'retrieveYpoConciergeTopics',
    emailYpoConciergeHelp: 'emailYpoConciergeHelp',

    //chapter Module Actions
    getChapterActivityList: 'getChapterActivityList',
    createActivityPost: 'createActivityPost',
    uploadFilesToTemporaryStorage: 'uploadFilesToTemporaryStorage',
    getBasicOptionsForSpeaker: 'getBasicOptionsForSpeaker',
    submitPostEdit: 'submitPostEdit',
    sendDeletePost: 'sendDeletePost',
    sendInappropriatePost: 'sendInappropriatePost',
    sendRemoveMention: 'sendRemoveMention',
    hidePost: 'hidePost',
    unHidePost: 'unHidePost',
    sendLike: 'sendLike',
    sendUnlike: 'sendUnlike',
    createUpdateAboutMessage: 'createUpdateAboutMessage',
    getMoreCommentsForPost: 'getMoreCommentsForPost',
    getChairMessage: 'getChairMessage',
    getChapterMessage: 'getChapterMessage',
    createChapterMessage: 'createChapterMessage',
    UpdateChairMessage: 'UpdateChairMessage',
    createChairMessage: 'createChairMessage',
    getAboutView: 'getAboutView',
    createAboutMessage: 'createAboutMessage',
    updateAboutMessage: 'updateAboutMessage',
    getChapterAwards: 'getChapterAwards',
    getFeatureEvents: 'getFeatureEvents',
    createFeatureEvent: 'createFeatureEvent',
    deleteFeatureEvent: 'deleteFeatureEvent',
    reorderFeatureEvent: 'reorderFeatureEvent',
    getCommentedUsers: 'getCommentedUsers',
    saveReorderedFeatureEvent: 'saveReorderedFeatureEvent',
    getLikedUsers: 'getLikedUsers',
    downloadPostAttachment: 'downloadPostAttachment',
    getAdminFeedList: 'getAdminFeedList',
    getChapterOfficersData: 'getChapterOfficersData',
    getTransactionHubContent: 'getTransactionHubContent',
    saveTransactionHubContent: 'saveTransactionHubContent',
    getStateOrProvinces: 'getStateOrProvinces',
    getDownloadMemberDirectory: 'getDownloadMemberDirectory',
    getIsPMTeamMember: 'getIsPMTeamMember',
    registerInAdobe: 'registerInAdobe',
    getChapterQuickLinks: 'getChapterQuickLinks',
    createChapterQuickLinks: 'createChapterQuickLinks',
    modifyDisplayOrderChapterQuickLinks: 'modifyDisplayOrderChapterQuickLinks',

    //Region Chapter List
    getChapterList: 'getChapterList',
    getAllChapterList: 'getAllChapterList',
    //End

    getUpcomingEventList: 'getUpcomingEventList',
    getUpcomingEventListForCAView: 'getUpcomingEventListForCAView',
    saveUpcomingEvent: 'saveUpcomingEvent',
    rejectUpcomingEvent: 'rejectUpcomingEvent',

    //sponsor module actions
    getSponsorsList: 'getSponsorsList',
    getSponsorIcon: 'getSponsorIcon',
    postChapterSponsor: 'postChapterSponsor',

    //my account action
    getProfileInformation: 'getProfileInformation',
    setDataDogUserInfo: 'setDataDogUserInfo',
    changeUserName: 'changeUserName',
    changePassword: 'changePassword',
    getProspectsList: 'getProspectsList',
    ProspectsResultsDownload: 'ProspectsResultsDownload',
    createVote: 'createVote',
    getVote: 'getVote',

    //Privacy Settings Action
    getNotification: 'getNotification',
    getVisibilityInformation: 'getVisibilityInformation',
    saveNotification: 'saveNotification',
    saveVisibilityPreferences: 'saveVisibilityPreferences',
    getEmailPreferences: 'getEmailPreferences',
    saveEmailPreferences: 'saveEmailPreferences',

    //Files and Media
    saveFilesandMediaReorderList: 'saveFilesandMediaReorderList',
    getChapterAdminForumManagementDetails: 'getChapterAdminForumManagementDetails',
    getChapterOfficerManagemet: 'getChapterOfficerManagemet',
    getChapterAdminProspectManagement: 'getChapterAdminProspectManagement',
    getChapterAdminProspectsReadyToPay: 'getChapterAdminProspectsReadyToPay',
    getQ2ReportUpdateSalesforceLink: 'getQ2ReportUpdateSalesforceLink',
    createDirectory: 'createDirectory',
    uploadFiles: 'uploadFiles',
    getFilesAndMedia: 'getFilesAndMedia',
    updateDirectory: 'updateDirectory',
    uploadFilesAndMedia: 'uploadFilesAndMedia',
    deleteFilesAndMedia: 'deleteFilesAndMedia',
    getDownloadFile: 'getDownloadFile',
    getDownloadFolders: 'getDownloadFolders',

    //Tools Menu Action
    getResourceLinks: 'getResourceLinks',
    getMyQuickLinks: 'getMyQuickLinks',
    getForumQuickLinks: 'getForumQuickLinks',

    //News Feed
    getNewsFeed: 'getNewsFeed',
    updateNewsFeed: 'updateNewsFeed',

    //Member Directory
    getMemberDirectorySearchResults: 'getMemberDirectorySearchResults',
    getInitialMemberDirectorySearchResults: 'getInitialMemberDirectorySearchResults',
    getNextMemberDirectorySearchResults: 'getNextMemberDirectorySearchResults',
    getMemberDirectorySearchResultByLastName: 'getMemberDirectorySearchResultByLastName',
    initiateTypeAheadSearch: 'initiateTypeAheadSearch',
    initiatePeopleSearch: 'initiatePeopleSearch',
    getSortByLastNameList: 'getSortByLastNameList',
    getVCardDetails: 'getVCardDetails',
    sendRibbonState: 'sendRibbonState',
    clearRibbonState: 'clearRibbonState',
    getSalesforceRedirectUrl: 'getSalesforceRedirectUrl',

    //App Notifcation related
    saveFCMToken: 'saveFCMToken',
    getUnReadNotificationCount: 'getUnReadNotificationCount',
    getnotifications: 'getnotifications',
    updateNotificationsToIsRead: 'updateNotificationsToIsRead',
    deletePersonFcmToken: 'deletePersonFcmToken',

    //Event Directory
    getEventDirectorySearchResults: 'getEventDirectorySearchResults',
    getInitialEventDirectorySearchResults: 'getInitialEventDirectorySearchResults',
    getNextEventDirectorySearchResults: 'getNextEventDirectorySearchResults',
    getMemberVoucher: 'getMemberVoucher',
    initiateEventSearch: 'initiateEventSearch',
    clearAllEventFilters: 'clearAllEventFilters',
    initiateEventsTypeAheadSearch: 'initiateEventsTypeAheadSearch',

    // YPO Events
    getYpoEvents: 'getYpoEvents',
    getInitialYpoEvents: 'getInitialYpoEvents',
    getYpoEventsTypeAheadSearch: 'getYpoEventsTypeAheadSearch',
    getYpoEventsRegionsList: 'getYpoEventsRegionsList',
    getUnfilteredYpoEvents: 'getUnfilteredYpoEvents',
    getMoreYpoEvents: 'getMoreYpoEvents',

    //Content Directory
    getContentDirectorySearchResults: 'getContentDirectorySearchResults',
    getInitialContentDirectorySearchResults: 'getInitialContentDirectorySearchResults',
    getNextContentDirectorySearchResults: 'getNextContentDirectorySearchResults',
    clearAllContentFilters: 'clearAllContentFilters',

    //Community Directory
    getCommunityAutoCompleteSearchResults: 'getCommunityAutoCompleteSearchResults',
    getInitialCommunityDirectorySearchResults: 'getInitialCommunityDirectorySearchResults',
    getNextCommunityDirectorySearchResults: 'getNextCommunityDirectorySearchResults',
    initiateCommunityTypeAheadSearch: 'initiateCommunityTypeAheadSearch',
    sendCommunityRibbonState: 'sendCommunityRibbonState',
    clearCommunityRibbonState: 'clearCommunityRibbonState',
    getCommunityDirectoryResults: 'getCommunityDirectoryResults',
    getNextCommunityDirectoryResults: 'getNextCommunityDirectoryResults',
    clearAllCommunityFilters: 'clearAllCommunityFilters',

    //Content Directory
    getContentAutoCompleteSearchResults: 'getContentAutoCompleteSearchResults',

    //forum toolkit
    getForumToolKitList: 'getForumToolKitList',
    getForumToolKitToken: 'getForumToolKitToken',
    getForumToolKitListContent: 'getForumToolKitListContent',
    getForumSampleandAgendas: 'getForumSampleandAgendas',
    setPersonConnect: 'setPersonConnect',
    getMemberConnectionList: 'getMemberConnectionList',
    getMemberFollowList: 'getMemberFollowList',
    getForumToolKitExercises: 'getForumToolKitExercises',

    //Member profile
    getYPOAwards: 'getYPOAwards',
    getBiography: 'getBiography',
    getTrainingAndCertifications: 'getTrainingAndCertifications',
    getAccomplishments: 'getAccomplishments',
    getProfessionalRoles: 'getProfessionalRoles',
    getCompanyInvestments: 'getCompanyInvestments',
    getFamilyInterests: 'getFamilyInterests',
    getCommunities: 'getCommunities',
    getFamilyDetails: 'getFamilyDetails',
    getEducationDetails: 'getEducationDetails',
    getContactInformation: 'getContactInformation',
    getNetworks: 'getNetworks',
    getEvents: 'getEvents',
    getNetworkChapters: 'getNetworkChapters',
    getNetworkRegions: 'getNetworkRegions',
    getMyActivity: 'getMyActivity',
    getAccessToken: 'getAccessToken',
    getAccessTokenDecoded: 'getAccessTokenDecoded',
    getCurrentUserId: 'getCurrentUserId',
    getProfessionalExperience: 'getProfessionalExperience',
    getUserProfile: 'getUserProfile',
    getProfileConnection: 'getProfileConnection',
    addConnection: 'addConnection',
    addBulkConnections: 'addBulkConnections',
    getProfileFollowing: 'getProfileFollowing',
    addProfileFollowing: 'addProfileFollowing',
    getIndustory: 'getIndustory',
    searchExternalConnection: 'searchExternalConnection',
    searchCourseAndCertificate: 'searchCourseAndCertificate',
    getCompanyTypes: 'getCompanyTypes',
    getEmergencyContactRelationTypes: 'emergencyContactRelationTypes',
    getCommunitiesGroups: 'getCommunitiesGroups',
    getAssetSummaryShortcut: 'getAssetSummaryShortcut',
    getAssetSummary: 'getAssetSummary',
    addDuplicateAssets: 'addDuplicateAssets',
    deleteAssets: 'deleteAssets',
    getCountryAndRegions: 'getCountryAndRegions',
    updateSubmitAssetDetails: 'updateSubmitAssetDetails',
    saveSubmitAssetDetails: 'saveSubmitAssetDetails',
    checkPersonAssetMappingExists: 'checkPersonAssetMappingExists',
    getPendingAssets: 'getPendingAssets',
    denyAssetRequest: 'denyAssetRequest',
    approveAssetRequest: 'approveAssetRequest',
    saveAssetDetails: 'saveAssetDetails',
    handleLaunchOfMemberProfile: 'handleLaunchOfMemberProfile',
    uploadBulkAddFile: 'uploadBulkAddFile',
    downloadBulkAddTemplate: 'downloadBulkAddTemplate',
    getUserProfileWithoutWrapper: 'getUserProfileWithoutWrapper',
    getEmailExists: 'getEmailExists',
    getChampionPositions: 'getChampionPositions',
    getCategoryLinks: 'getCategoryLinks',
    saveQuickLinks: 'saveQuickLinks',
    getProfileDropDowns: 'getProfileDropDowns',
    saveImpersonationRole: 'saveImpersonationRole',

    //Edit Profile
    editEducation: 'editEducation',
    saveEducation: 'saveEducation',
    deleteEducation: 'deleteEducation',
    searchEducation: 'searchEducation',
    editProfessionalExperience: 'editProfessionalExperience',
    saveProfessionalExperience: 'saveProfessionalExperience',
    saveBiography: 'saveBiography',
    deleteProfessionalExperience: 'deleteProfessionalExperience',
    searchProfessionalExperience: 'searchProfessionalExperience',
    updateRelationship: 'updateRelationship',
    saveRelationships: 'saveRelationships',
    deleteRelationship: 'deleteRelationship',
    uploadProfilePhoto: 'uploadProfilePhoto',
    getSearchProfile: 'getSearchProfile',
    updateAcomplishment: 'updateAcomplishment',
    deleteAccomplishment: 'deleteAccomplishment',
    saveAccomplishments: 'saveAccomplishments',
    updateCompanyInvestment: 'updateCompanyInvestment',
    deleteCompanyInvestment: 'deleteCompanyInvestment',
    saveCompanyInvestment: 'saveCompanyInvestment',
    updateProfessionalRoles: 'updateProfessionalRoles',
    deleteProfessionalRoles: 'deleteProfessionalRoles',
    saveProfessionalRoles: 'saveProfessionalRoles',
    updateTrainingAndCertification: 'updateTrainingAndCertification',
    deleteTrainingAndCertification: 'deleteTrainingAndCertification',
    saveTrainingAndCertification: 'saveTrainingAndCertification',
    saveProfileSummaryDetails: 'saveProfileSummaryDetails',
    updatePersonExternalConnection: 'updatePersonExternalConnection',
    savePersonExternalConnection: 'savePersonExternalConnection',
    deletePersonExternalConnection: 'deletePersonExternalConnection',
    getBusinessInterests: 'getBusinessInterests',
    savePersonInterests: 'savePersonInterests',
    saveRelationshipStatus: 'saveRelationshipStatus',
    saveEmailInformation: 'saveEmailInformation',
    savePhoneInformation: 'savePhoneInformation',
    saveEmergencyContact: 'saveEmergencyContact',
    saveAddress: 'saveAddress',
    updateSocialNetworkDetails: 'updateSocialNetworkDetails',
    saveExecutiveAssistant: 'saveExecutiveAssistant',
    verifyEmailExitsinDB: 'verifyEmailExitsinDB',

    //ChapterAdmin
    getChapterAdmin: 'getChapterAdmin',
    getChapterAdminSFReports: 'getChapterAdminSFReports',

    //Network Related Communities
    getRelatedCommunities: 'getRelatedCommunities',
    createRelatedCommunity: 'createRelatedCommunity',
    deleteRelatedCommunity: 'deleteRelatedCommunity',
    updateRelatedCommunity: 'updateRelatedCommunity',
    getSubNetworksData: 'getSubNetworksData',
    getAllRequestedJoinees: 'getAllRequestedJoinees',
    getAllNetworks: 'getAllNetworks',
    getNetworkPageContent: 'getNetworkPageContent',
    getCommunityPendingRequests: 'getCommunityPendingRequests',
    approveRequest: 'approveRequest',
    sendRemovePostModeration: 'sendRemovePostModeration',
    getInviteesList: 'getInviteesList',
    applyToJoinNetwork: 'applyToJoinNetwork',
    resignFromCommunity: 'resignFromCommunity',
    sendHidePostModeration: 'sendHidePostModeration',
    getYPONetworks: 'getYPONetworks',
    saveYpoNetworkCategories: 'saveYpoNetworkCategories',
    modifyDisplayOrderNetworkCategories: 'modifyDisplayOrderNetworkCategories',
    updateRelatedContentData: 'updateRelatedContentData',
    getFocusList: 'getFocusList',
    getGroupConfiguration: 'getGroupConfiguration',
    getPendingRequestList: 'getPendingRequestList',
    getCommunityMembers: 'getCommunityMembers',
    toggleGroupMemberAdminPermission: 'toggleGroupMemberAdminPermission',
    removeGroupMember: 'removeGroupMember',
    getAllCommunityAdminList: 'getAllCommunityAdminList',
    getIsLastAdmin: 'getIsLastAdmin',
    requestGroupPost: 'requestGroupPost',
    reviewRequest: 'reviewRequest',
    sendInviteesList: 'sendInviteesList',
    canViewPendingAssetRequest: 'canViewPendingAssetRequest',

    // Messenger
    ensureMessengerSession: 'ensureMessengerSession',
    persistConversation: 'persistConversation',
    createChatGroup: 'createChatGroup',
    joinConversation: 'joinConversation',
    renameConversation: 'renameConversation',
    inviteToConversation: 'inviteToConversation',
    removeFromConversation: 'removeFromConversation',
    deleteConversation: 'deleteConversation',
    removeConnection: 'removeConnection',
    connectToMembers: 'connectToMembers',
    sendMessage: 'sendMessage',
    fetchConversationHistory: 'fetchConversationHistory',
    setRoomReadMarkers: 'setRoomReadMarkers',
    fetchProfileData: 'fetchProfileData',

    // Recommended Events
    getRecommendedEvents: 'getRecommendedEvents',
    getRecommendedMembers: 'getRecommendedMembers',
    disposeRecommendedEvents: 'DisposeRecommendedEvents',
    disposeRecommendedMembers: 'DisposeRecommendedMembers',
    getReasonsToConnect: 'getReasonsToConnect',

    // Renewals
    getRenewalStatus: 'getRenewalStatus',

    //Forum Meetings
    getForumMeetingsView: 'getForumMeetingsView',

    //Assist Page
    getAssistPageTopics: 'getAssistPageTopics',
    createTopics: 'createTopics',
    createQuestion: 'createQuestion',
    saveTopic: 'saveTopic',
    saveQuestion: 'saveQuestion',
    saveAnswer: ' saveAnswer',
    saveTourReorderList: ' saveTourReorderList',
    saveAssistOrder: 'saveAssistOrder',
    getReleaseNotes: 'getReleaseNotes',
    updateReleaseNotes: 'updateReleaseNotes',

    //Feedback Form
    getFeedbackQuestions: 'getFeedbackQuestions',
    updateQuestionType: 'updateQuestionType',
    submitFeedbackForm: 'submitFeedbackForm',
    getTakeTourVideos: 'getTakeTourVideos',
    getNewsAndComingSoonFiles: 'getNewsAndComingSoonFiles',
    updateNewAndComingSoonFile: 'updateNewAndComingSoonFile',
    deleteTopic: 'deleteTopic',
    deleteArticle: 'deleteArticle',
    isAdminUser: 'isAdminUser',
    updateTakeTourVideoTitle: 'updateTakeTourVideoTitle',
    deleteTakeTourVideo: 'deleteTakeTourVideo',
    downloadTakeTourVideo: 'downloadTakeTourVideo',

    //Speaker Page
    getMemberAssociationList: 'getMemberAssociationList',
    getSpeakerRegistrationStatus: 'getSpeakerRegistrationStatus',
    getLanguagesList: 'getLanguagesList',
    getYPOSpeakers: 'getYPOSpeakers',
    getTopicsList: 'getTopicsList',
    getFeeRangeList: 'getFeeRangeList',
    getMemberProfileDetails: 'getMemberProfileDetails',
    getPendingApplicants: 'getPendingApplicants',
    getPendingApplicantsCount: 'getPendingApplicantsCount',
    getReviewedApplicants: 'getReviewedApplicants',
    uploadSpeakerRegistrationFiles: 'uploadSpeakerRegistrationFiles',
    uploadSpeakerRegistrationData: 'uploadSpeakerRegistrationData',
    uploadSpeakerRegistrationProfileImage: 'uploadSpeakerRegistrationProfileImage',
    uploadSpeakerRegistrationPresentation: 'uploadSpeakerRegistrationPresentation',
    submitRegistrationForm: 'submitRegistrationForm',
    getCountryList: 'getCountryList',
    getRegionListForCFF: 'getRegionListForCFF',
    getFeesRange: 'getFeesRange',
    initiateSpeakerTypeAheadSearch: 'initiateSpeakerTypeAheadSearch',

    //Chapter Waiver
    getWaiverTypes: 'getWaiverTypes',
    getListOfWaivers: 'getListOfWaivers',
    getWaiverQuestions: 'getWaiverQuestions',
    getWaiverDetails: 'getWaiverDetails',
    getPRPRole: 'getPRPRole',
    uploadWaiverFiles: 'uploadWaiverFiles',
    deleteWaiverFiles: 'deleteWaiverFiles',
    sendWaiverBackToChapterOfficer: 'sendWaiverBackToChapterOfficer',
    submitWaiverRequest: 'submitWaiverRequest',
    saveWaiverRequest: 'saveWaiverRequest',
    sendToRegion: 'sendToRegion',
    sendToPRP: 'sendToPRP',
    getPRPMemberList: 'getPRPMemberList',
    saveRegionalOfficerComments: 'saveRegionalOfficerComments',
    submitVote: 'submitVote',
    savePRPMemberDenyReason: 'savePRPMemberDenyReason',
    getFinalizeEmailRecipients: 'getFinalizeEmailRecipients',
    searchWaiverRequests: 'searchWaiverRequests',
    searchUsersForFinalizeMail: 'searchUsersForFinalizeMail',
    getCorporationTypes: 'getCorporationTypes',
    getTitleTypes: 'getTitleTypes',

    //Businesses Page
    getSearchEstablishments: 'getSearchEstablishments',
    getSearchLocations: 'getSearchLocations',
    getSearchAssets: 'getSearchAssets',
    getBusinessCommunityId: 'getBusinessCommunityId',
    getBecomeASpeaker: 'getBecomeASpeaker',
    getSearchSpeakers: 'getSearchSpeakers',
    getRejectApplicant: 'getRejectApplicant',
    getApproveApplicant: 'getApproveApplicant',
    getSpeakerProfile: 'getSpeakerProfile',
    saveEditedSpeakerProfile: 'saveEditedSpeakerProfile',
    getIsSpeakerApproved: 'getIsSpeakerApproved',
    getCanViewSpeakerAdminDirectory: 'getCanViewSpeakerAdminDirectory',
    updateSpeakerProfileImage: 'updateSpeakerProfileImage',

    //Event Attendees
    getEventAttendees: 'getEventAttendees',

    //Chapter Health Rating
    getChapterHealthRating: 'getChapterHealthRating',
    getChapterAgeDemographics: 'getChapterAgeDemographics',

    //Ypo Common Components
    getChapterChairMessage: 'getChapterChairMessage',
    getChapterEventsAttendees: 'getChapterEventsAttendees',
    getChapterHealthPoints: 'getChapterHealthPoints',
    getChapterElectedOfficers: 'getChapterElectedOfficers',
    getChapterHealthRatingTile: 'getChapterHealthRating',
    getChapterMyQuickLinks: 'getChapterMyQuickLinks',
    getChapterAnnouncement: 'getChapterAnnouncement',
    getChapterSponsorsList: 'getChapterSponsorsList',
    getChapterFilesAndMedia: 'getChapterFilesAndMedia',

    //PoliciesProcedure
    getPoliciesHeadings: 'getPoliciesHeadings',
    getPoliciesAndProceduresSearch: 'getPoliciesAndProceduresSearch',
    getArticleData: 'getArticleData',

    //Create Events //TODO: - removing all these constants until Beta release if complete
    getTimeZones: 'getTimeZones',
    submitChapterEvent: 'submitChapterEvent',
    getCventLookup: 'getCventLookup',
    getEventCustomField: 'getEventCustomField',

    //Champs Page
    getChapterGenderDemographics: 'getChapterGenderDemographics',
    getEmailSenderList: 'getEmailSenderList',
    getEmailRecipient: 'getEmailRecipient',
    getEmailRecipientList: 'getEmailRecipientList',
    getChapterEventsDownloadExcelFile: 'getChapterEventsDownloadExcelFile',
    getAnnouncementInfo: 'getAnnouncementInfo',
    createAnnouncementAPI: 'createAnnouncementAPI',
    getAllAnnouncements: 'getAllAnnouncements',
    deleteAnnouncements: 'deleteAnnouncements',
    makeOnlineAnnouncement: 'makeOnlineAnnouncement',
    updateAnnouncement: 'updateAnnouncement',
    getAllReportsNames: 'getAllReportsNames',
    getReportData: 'getReportData',
    saveEmailRecipients: 'saveEmailRecipients',
    createNewEmail: 'createNewEmail',
    saveEmailContent: 'saveEmailContent',
    getForumCategory: 'getForumCategory',
    champsUploadAttachments: 'champsUploadAttachments',
    createSignature: 'createSignature',
    getSignatureList: 'getSignatureList',
    updateSignature: 'updateSignature',
    deleteSignature: 'deleteSignature',
    emailPreview: 'emailPreview',
    getEmails: 'getEmails',
    deleteEmail: 'deleteEmail',
    sendEmail: 'sendEmail',
    getEmailContents: 'getEmailContents',
    scheduleEmail: 'scheduleEmail',
    getAllCustomEmailGroups: 'getAllCustomEmailGroups',
    getMemberDetailsInfo: 'getMemberDetailsInfo',
    createCustomEmailGroup: 'createCustomEmailGroup',
    deleteCustomEmailGroup: 'deleteCustomEmailGroup',
    editCustomEmailGroup: 'editCustomEmailGroup',
    getCustomGroupsList: 'getCustomGroupsList',

    //Champs - Events
    submitEvent: 'submitEvent',
    getEventById: 'getEventById',
    getCommunityUsers: 'getCommunityUsers',
    getEventInfo: 'getEventInfo',
    getEventCustomFields: 'getEventCustomFields',
    launchEvent: 'launchEvent',
    deleteEventAttachment: 'deleteEventAttachment',
    getNextBoardMeetingEvent: 'getNextBoardMeetingEvent',

    //OpenAuth API
    loginPrivacyTermsOfUse: 'loginPrivacyTermsOfUse',
    getUnRegisteredEvents: 'getUnRegisteredEvents',

    //MFASettings
    getUserMFASettings: 'getUserMFASettings',
    removeMFASettings: 'removeMFASettings',
    saveMFASettings: 'saveMFASettings',
    confirmMFASettings: 'confirmMFASettings',
    resendMFASettings: 'resendMFASettings',
    initiatePasswordResetFlow: 'initiatePasswordResetFlow',
    getAllSecurityQuestions: 'getAllSecurityQuestions',
    getPasswordPolicies: 'getPasswordPolicies',

    //Connect Plus
    getConnectPlusRedirects: 'getConnectPlusRedirects',

    //Chapter Studio
    getChapterStudioResources: 'getChapterStudioResources',
    addFavoriteToChapterStudio: 'addFavoriteToChapterStudio',
    getChapterStudioAnnouncements: 'getChapterStudioAnnouncements',

    // Manage Chapter Studio
    getAllChapterStudioAnnouncements: 'getAllChapterStudioAnnouncements',
    getChapterStudioAnnouncementById: 'getChapterStudioAnnouncementById',
    getChapterStudioPicklists: 'getChapterStudioPicklists',
    createChapterStudioAnnouncement: 'createChapterStudioAnnouncement',
    saveChapterStudioAnnouncementDraft: 'saveChapterStudioAnnouncementDraft',
    saveChapterStudioAnnouncement: 'saveChapterStudioAnnouncement',
    getPastChapterStudioAnnouncements:'getPastChapterStudioAnnouncements',

    // Snackbar
    setToastMessage: 'setToastMessage',
    hideSnackbar: 'hideSnackbar',
};
